import React from 'react';
import { useTheme } from '@mui/material/styles';
import {Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, useMediaQuery, Link} from '@mui/material/';

interface Props {
    isDialogOpen: boolean,
    closeDialog: ()=> void
}

const FileLegalComplaint = (props: Props): JSX.Element => {
  
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Dialog
        fullScreen={fullScreen}
        open={props.isDialogOpen}
        onClose={props.closeDialog}
        maxWidth={'md'}
        aria-labelledby="how to file a legal complaint"
      >
        <DialogTitle>
          Requesting a Legal Review
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
          <>
            <p>Individuals with information concerning possible violations of the campaign finance laws may file a request for review in writing with OCPF. The identity of the individual requesting the review is 
   kept confidential and is not revealed to the subject of the review, or the public. OCPF does not comment on any matter that is under review or investigation. In fact, 
   the office also does not confirm or deny the receipt of any requests for review or the existence 
                of an investigation until such investigation is completed.  Requests for review are accepted by:
            </p>
            <ul>
            <li><Link href="mailto:ocpf@mass.gov?subject=Request for Review">
                Email Your Request</Link></li>
            <li>fax:  (617) 727-6549 or</li>
            <li>US Mail:  Office of Campaign and Political Finance<br />
                One Ashburton Place, Room 411<br />
                Boston, MA 02108<br />
                Attention:  Legal review request</li></ul>
                <p>Requests for review should include the following:</p>
                <ul>
                 <li>The requesting party's contact information, if a direct response is desired;</li>
                <li>A description of a specific activity or transaction that has raised an issue
                    of concern; and</li>
                <li>Any accompanying documentation or other data that the requesting party deems 
                    pertinent.</li></ul>
                <p>Reviews may be resolved in one of several ways. The most common resolution is in the form of a 
   public resolution letter (PRL), which states OCPF's conclusions regarding a matter, such as whether 
   a subject did not comply with the campaign finance law, whether there is no reason to believe there 
   was a violation, or whether the office is taking no further action after its review. Such letters are public record.</p>
<p>Some requests for review are resolved by closing the matter administratively. In these instances, 
   the review revealed no evidence to suggest any violation of the campaign finance law occurred. These 
   reviews are often resolved informally; by a telephone call or letter to the requesting party advising 
   the individual that there is no reason to believe, based on the information submitted, that a violation 
   has occurred.</p>
                <p>In matters of more significant violations, OCPF may enter into a disposition agreement with the 
   subject of an investigation.  In these agreements, the parties agree to specific facts and the subject 
   agrees to take various corrective actions, such as additional or amended disclosure reports and payments 
   to the Commonwealth. Finally, OCPF has the option of referring matters to the Office of the Attorney 
   General for further action.</p>
          </>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={props.closeDialog}>Close</Button>
        </DialogActions>
      </Dialog>
  );
};

export default FileLegalComplaint;
